
import { defineComponent, ErrorCodes, mergeProps } from "vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import VueElementLoading from "vue-element-loading";
import consts from "@/const/const";
import { useCookies } from "vue3-cookies";
const detailRepository = RepositoryFactory.getQuery("detail");
const DetailAccesslogRepository = RepositoryFactory.post("detailAccesslog");

// URLを取得
const getParameters = location.search;
// console.log(getParameters);

function import_script(urls: string[]) {
  return Promise.all(
    urls.map(function (url: string) {
      return new Promise(function (resolve) {
        const script = document.createElement("script");
        script.src = url;
        script.onload = resolve;
        script.async = true;
        document.head.appendChild(script);
      });
    })
  );
}
function import_link(param: string) {
  const link = document.createElement("link");
  link.rel = "canonical";
  link.href = consts.yumenaviinfo + "vue/lecture.html?gnkcd=" + param;
  document.head.appendChild(link);
}
function import_noindex() {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex";
  document.head.prepend(meta);
}
function import_ogp(param: string) {
  const meta1 = document.createElement("meta");
  meta1.name = "twitter:card";
  meta1.content = "summary";
  document.head.appendChild(meta1);
  const meta2 = document.createElement("meta");
  meta2.name = "twitter:site";
  meta2.content = "@yumenavi_info";
  document.head.appendChild(meta2);
  const meta3 = document.createElement("meta");
  meta3.setAttribute("property", "og:url");
  meta3.content = consts.yumenaviinfo;
  document.head.appendChild(meta3);
  const meta4 = document.createElement("meta");
  meta4.setAttribute("property", "og:title");
  meta4.content = "夢ナビ　興味・関心は学問の世界へつながっている";
  document.head.appendChild(meta4);
  const meta5 = document.createElement("meta");
  meta5.setAttribute("property", "og:description");
  meta5.content =
    "わくわくする学問さがしを始めよう！好きなこと、普段から関心のあることはなに？あなたの関心事には自分でも気づいていない学問への可能性がいっぱい！";
  document.head.appendChild(meta5);
  const meta6 = document.createElement("meta");
  meta6.setAttribute("property", "og:image");
  meta6.content = param;
  document.head.appendChild(meta6);
  const meta7 = document.createElement("meta");
  meta7.name = "thumbnail";
  meta7.content = param;
  document.head.appendChild(meta7);
}
/**
 * Get the URL parameter value
 *
 * @param name {string} パラメータのキー文字列
 * @return url {url} 対象のURL文字列
 */
function getParam(name: string, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default defineComponent({
  name: "Lecture",
  components: {
    AppHeader,
    AppFooter,
    VueElementLoading,
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {
      posts: [],
      gakumonGroup: "",
      msgbcid: "",
      addTitle: "",
      orgTitle: "",
      orgMessage: "",
      lectureUrl: "",
      isModalFaq1Open: false,
      isModalFaq2Open: false,
      isModalFaq3Open: false,
      consts: consts,
      loadingshow: false,
      isUniversity: false,
      isYL: false,
      isPortal: false,
      isMember: false,
      isMypage: false,
      paramUniv: "",
      paramYL: "",
      getGENKOCD: "",
      errorcode: null,
      whytitle: "",
      whyreason: "",
      whyreferdoc1name: "",
      whyreferdoc1url: "",
      whyreferdoc2name: "",
      whyreferdoc2url: "",
    };
  },
  computed: {
    // 学問系統によってクラスを変更する
    classFlag: function () {
      return function (gakumonGroup: string) {
        let searchNumber = Number(gakumonGroup?.slice(2, 5));
        if (searchNumber >= 470) {
          return "c-gakumon-type04";
        } else if (searchNumber >= 220) {
          return "c-gakumon-type03";
        } else if (searchNumber >= 110) {
          return "c-gakumon-type02";
        } else {
          return "c-gakumon-type01";
        }
      };
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    import_script(["./js/lazysizes.min.js"]);
    import_script(["./js/ls.unveilhooks.min.js"]);
    // twitter用
    import_script(["./js/twitter.js"]);
    import_script(["./js/gatag.js"]);

    /**
     * .js-scrollが存在する場合.is-activeを付与
     */
    document.querySelectorAll(".js-scroll").forEach((target) => {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-active");
          } else {
            entry.target.classList.remove("is-active");
          }
        });
      });
      io.observe(target);
    });
  },

  methods: {
    async fetch() {
      this.loadingshow = true;
      let detaildata: any;
      try {
        const { data } = await detailRepository.getQuery(getParameters);
        detaildata = data;
      } catch (err) {
        this.loadingshow = false;
        alert("データの取得に失敗しました。");
        import_noindex();
        return false;
      }
      if (!detaildata.errorcode || detaildata.errorcode == 0) {
        if (getParam("University") == "V" || getParam("YL") == "1") {
          if (getParam("University") == "V") {
            this.isUniversity = true;
            this.paramUniv = "&University=V";
          }
          if (getParam("YL") == "1") {
            this.isYL = true;
            this.paramYL = "&YL=1";
          }
          // 講義を28件にフィルタリング
          detaildata.daigakugenkoes = detaildata.daigakugenkoes.slice(0, 28);
        } else {
          // 講義を4件にフィルタリング
          detaildata.daigakugenkoes = detaildata.daigakugenkoes.slice(0, 4);
        }
        if (getParam("From") == "portal") {
          this.isPortal = true;
        }
        if (getParam("From") == "member") {
          this.isMember = true;
        }
        if (getParam("From") == "mypage") {
          this.isMypage = true;
        }
        try {
          // 入ってこない(nullですらないもの)可能性のあるものをtemplateに書いているとエラーになる
          this.whytitle = detaildata.kyoju.why.title;
          this.whyreason = detaildata.kyoju.why.reason;
          this.whyreferdoc1name = detaildata.kyoju.why.referdoc1name;
          this.whyreferdoc1url = detaildata.kyoju.why.referdoc1url;
          this.whyreferdoc2name = detaildata.kyoju.why.referdoc2name;
          this.whyreferdoc2url = detaildata.kyoju.why.referdoc2url;
        } catch {
          // 何もしない
        }
        // OGP
        import_ogp(detaildata.genko.imageurl);
        // 原稿コード以外のパラメータあれば付与
        if (
          ((getParam("gnkcd") != null && getParam("gnkcd")?.length == 7) ||
            (getParam("GNKCD") != null && getParam("GNKCD")?.length == 7)) &&
          getParameters.length > 14
        ) {
          // 原稿コード付きlinkタグを追加
          import_link(detaildata.genko.genkocode);
        }
        // 紹介動画のフラグ
        this.msgbcid = detaildata.kyoju.msgbcid;
        if (this.msgbcid) {
          // Brightcove プレーヤー 設定の読み込み
          import_script([
            "https://players.brightcove.net/5974301585001/R1t9Dt6OZ_default/index.min.js",
          ]).then(function () {
            // ロード後に実行したい処理
            import_script(["./js/brightcove.js"]);
          });
        }
        // タイトルに講義名と先生のお名前を追加する
        // 学部、学科、学位は値があれば結合
        // this.addTitle = detaildata.kyoju.daigakuname + " " + detaildata.kyoju.gakubu + " " + detaildata.kyoju.gakka + " " +  detaildata.kyoju.gakui + " " + detaildata.kyoju.name + "先生";
        this.addTitle = detaildata.kyoju.daigakuname;
        if (detaildata.kyoju.gakubu != null)
          this.addTitle += " " + detaildata.kyoju.gakubu;
        if (detaildata.kyoju.gakka != null)
          this.addTitle += " " + detaildata.kyoju.gakka;
        if (detaildata.kyoju.gakui != null)
          this.addTitle += " " + detaildata.kyoju.gakui;
        this.addTitle += " " + detaildata.kyoju.name + "先生";
        document.title = detaildata.genko.title + " | " + document.title;
        // SNS用にタイトルなど
        this.orgTitle = "夢ナビ 大学教授がキミを学問の世界へナビゲート";
        this.orgMessage = "本学教員のわくわくする学問を紹介します！ ";
        this.lectureUrl = encodeURIComponent(location.href);
        this.getGENKOCD = detaildata.genko.genkocode;
      } else if (detaildata.errorcode == 200) {
        import_noindex();
      }
      this.posts = detaildata;
      this.loadingshow = false;
      // よくわからないが実行されないことがあるので、できる限り後
      this.$nextTick(function () {
        // ビュー全体がレンダリングされた後にのみ実行されるコード
        import_script(["./js/anker.js?202202101640"]);
      });
      // アクセスログAPI呼び出し
      try {
        var sKbn = detaildata.detailaccesslog.SerKbn;
        if (!getParam("SerKbn")) {
          // SerKbnなし
          sKbn = "Y";
        }
        var params = {
          GNKCD: detaildata.detailaccesslog.GNKCD,
          CLCD: detaildata.detailaccesslog.CLCD,
          CLGAKOCD: detaildata.detailaccesslog.CLGAKOCD,
          KJCMNTCD: detaildata.detailaccesslog.KJCMNTCD,
          KJID: detaildata.detailaccesslog.KJID,
          UNIVERSITY: detaildata.detailaccesslog.UNIVERSITY,
          SerKbn: sKbn,
          Kw: detaildata.detailaccesslog.Kw,
        };
        // 成否問わず
        await DetailAccesslogRepository.post(params);
      } catch (err) {
        console.log("アクセスログの登録に失敗しました。");
      }
      // 最近見た講義のクッキー設定
      let recent_codes = this.cookies.get("RECENT_CODES");
      if (recent_codes) {
        let rc = recent_codes.split(",");
        if (rc.indexOf(detaildata.detailaccesslog.GNKCD) < 0) {
          rc.unshift(detaildata.detailaccesslog.GNKCD);
        }
        recent_codes = "";
        let setCnt = 0;
        for (let code of rc) {
          recent_codes += "," + code;
          setCnt++;
          if (setCnt == 10) {
            break;
          }
        }
        this.cookies.set("RECENT_CODES", recent_codes.slice(1), "30d");
      } else {
        this.cookies.set(
          "RECENT_CODES",
          detaildata.detailaccesslog.GNKCD,
          "30d"
        );
      }
    },
    onClickModalFaq1Toggle() {
      this.isModalFaq1Open = !this.isModalFaq1Open;
      this.modalLectureClosePostion();
    },
    onClickModalFaq2Toggle() {
      this.isModalFaq2Open = !this.isModalFaq2Open;
      this.modalLectureClosePostion();
    },
    onClickModalFaq3Toggle() {
      this.isModalFaq3Open = !this.isModalFaq3Open;
      this.modalLectureClosePostion();
    },
    modalLectureClosePostion() {
      Array.from(
        document.querySelectorAll(
          ".modal_LectureClose"
        ) as NodeListOf<HTMLImageElement>
      ).forEach((element) => {
        if (element.previousElementSibling && element.nextElementSibling) {
          element.style.left =
            element.previousElementSibling?.clientWidth / 2 +
            element.nextElementSibling.clientWidth / 2 -
            10 +
            "px";
          element.style.top =
            element.previousElementSibling?.clientHeight / 2 -
            element.nextElementSibling.clientHeight / 2 -
            15 +
            "px";
        }
      });
      // document.body.classList.add('js-modalOpen');
    },
    onClickClose() {
      if (/Chrome/i.test(navigator.userAgent)) {
        window.close();
      } else {
        window.open("about:blank", "_self")?.close();
      }
    },
    // 全角英数記号半角変換
    abc123ToHAN(strVal: string): string {
      var han = strVal.replace(/[！-～]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });
      // 文字コードシフトで対応できない文字の変換
      return han
        .replace(/”/g, '"')
        .replace(/’/g, "'")
        .replace(/‘/g, "`")
        .replace(/￥/g, "\\")
        .replace(/〜/g, "~")
        .replace(/\u3000/g, " ");
    },
    // 文章にスペースと改行を付与
    autoNewLine(sContent: string) {
      if (sContent == "" || sContent == undefined) return "";

      // 先頭に全角スペースを付与する。←全角スペースやめる
      // パイプ2文字("||")を改行に変更して表示する。改行後は先頭に全角スペースを付与する。←全角スペースやめる
      sContent = sContent.replace(/\|\|/g, "\r\n");

      return sContent;
    },
  },
});
